module.exports = __webpack_public_path__ + "img/exitexpress.3426a68e.jpeg";